import { FC, useCallback } from 'react';
import { useFilterContext } from 'entities/broadcast';
import { SelectorTab } from 'shared/ui';
import { broadcastTypeOptions } from '../model';

export const BroadcastFilterLive: FC = () => {
  const { live, setLive, setOffset } = useFilterContext();

  const customSetter = useCallback(
    (value?: boolean) => {
      setOffset(0);
      setLive(value);
    },
    [setLive, setOffset],
  );

  return (
    <SelectorTab<boolean | undefined>
      value={live}
      options={broadcastTypeOptions}
      onSelect={customSetter}
    />
  );
};
